export default "<router-outlet>\n  <app-spinner><app-title></app-title></app-spinner>\n</router-outlet>\n"